import { render, staticRenderFns } from "./POStatusCard.vue?vue&type=template&id=22bcd50b&scoped=true"
import script from "./POStatusCard.vue?vue&type=script&lang=ts"
export * from "./POStatusCard.vue?vue&type=script&lang=ts"
import style0 from "./POStatusCard.vue?vue&type=style&index=0&id=22bcd50b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bcd50b",
  null
  
)

export default component.exports